<div class="flex flex-col gap-2 p-4">
  @for (result of results; track result) {
    <app-lines-between-cities-result-list-item [line]="result"
      (lineSelected)="onResultClick.emit($event)" />
  }
</div>